/** Table custom styles and loading UI for react-data-table-component. */
export function getCustomStyles(hasClickHandler, enableResize = false) {
    const headCells = enableResize
        ? {
              position: 'relative',
              paddingLeft: '16px',
              paddingRight: '16px',
              fontSize: '14px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'visible',
              textOverflow: 'ellipsis',
          }
        : {
              paddingLeft: '16px',
              paddingRight: '16px',
              fontSize: '14px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
          };

    const cells = enableResize
        ? {
              paddingLeft: '16px',
              paddingRight: '16px',
              whiteSpace: 'normal',
              overflow: 'visible',
              wordBreak: 'break-word',
              height: 'auto',
              maxHeight: 'none',
          }
        : {
              paddingLeft: '16px',
              paddingRight: '16px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: 'break-all',
          };

    return {
        header: {
            style: { minHeight: '56px', padding: '16px' },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: '#e0e0e0',
            },
        },
        headCells: { style: headCells },
        cells: { style: cells },
        rows: {
            style: {
                height: 'auto',
                minHeight: enableResize ? 'auto' : '48px',
                maxHeight: 'none',
                backgroundColor: 'transparent',
                ...(hasClickHandler && {
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#f5f5f5' },
                }),
            },
        },
        ...(enableResize && {
            table: { style: { height: 'auto' } },
            tableWrapper: { style: { height: 'auto' } },
        }),
    };
}

export const LoadingComponent = (
    <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
        <div className="ms-3">
            <h5 className="mb-0">Loading data...</h5>
            <small className="text-muted">Please wait while we fetch your data</small>
        </div>
    </div>
);
